"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TextOverlay = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: black;
  font-size: 2rem;
  padding: 20px;
  box-sizing: border-box;
  z-index: 100;
  background: linear-gradient(to top right, rgba(0, 0, 0, 1), transparent);
`;
const ImageOverlay = ({ children }) => {
    return react_1.default.createElement(TextOverlay, null, children);
};
exports.default = ImageOverlay;
